<div *ngIf="environment && environment['PianificazioneAddOn']">

  <!-- FILTRI -->
  <div>
    <app-field-viewer
      [(Campi)]="environment['PianificazioneAddOn']['Filters']"
      [(Oggetto)]="filtro"
      (OnChange)="refresh()">
    </app-field-viewer>
  </div>

  <!-- LISTA + MAPPA -->
  <div class="table-responsive d-flex"
       *ngIf="interventiList && interventiList.length > 0">



    <!-- TABELLA -->
    <table class="table bg-white table-hover align-middle mb-0 no-wrap">



      <tbody>

        <tr *ngFor="let item of interventiList | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize; trackBy: trackByItem">
          <td (click)="select(item)">
            <input type="checkbox" [(ngModel)]="item.selected" style="margin-left: 10px; height: 30px;">
          <ng-container *ngFor="let campo of environment['PianificazioneAddOn']['CampiLista']['header']; trackBy: trackByField">

            

              <span class="font-14"
                    [ngClass]="{ 'badge badge-pill px-3': campoUtility.Colore(campo, item) }"
                    [ngStyle]="{
                      'color': campoUtility.Colore(campo, item) ? LightenColor(campoUtility.Colore(campo, item)) : '',
                      'background-color': campoUtility.Colore(campo, item)
                    }">

                    <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
                      <app-field-viewer *ngIf="!CampoIs(campo, ['objArray', 'replace'])" [Campi]="[campo]"   [Oggetto]="item"></app-field-viewer>
                      <ng-template [ngIf]="campo.type == 'replace' ">
                        {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
                      </ng-template>
                      <ng-template [ngIf]="campo.type == 'objArray' ">
                        <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                          {{obg[campo.field[i]]}}&nbsp;
                        </ng-container>
                      </ng-template>
                   
                   </ng-container>

              </span>

            
          </ng-container>
        </td>
        </tr>

      </tbody>
    </table>

    <!-- MAPPA -->
    <div class="col-8">
      <div class="card" style="height: 600px;">
        <div class="card-body" style="height: 100%;">
          <app-mappa
            [centerMaplat]="centerMaplat"
            [centerMaplon]="centerMaplon"
            [markers]="Markers"
            [circle]="circleMarker"
            (onCircleMarkerChange)="refresh()"
            (onMarkerClick)="onMarkerClick($event)">
          </app-mappa>
        </div>
      </div>
    </div>

  </div>
</div>
